module.exports = __webpack_public_path__ + "static/img/3.539b849.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/zh/3.png
// module id = vmrC
// module chunks = 0